import React from 'react';
import Grid from "@mui/material/Grid";
import { startOfWeek, endOfWeek } from "../../utils/dateFunctions";
import Roles from './Tables/Roles';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import ToggleButton from "@mui/material/ToggleButton";
import { userInfo } from '../../../adalConfig';
import FormModal from '../../components/FormModal';
import { Button } from '@mui/material';
import AddRole from './Forms/AddRole';

const RolesPage = (props) => {
    const [startDate, setStartDate] = React.useState(startOfWeek(new Date()));
    const [endDate, setEndDate] = React.useState(endOfWeek(new Date()));
    const [selection, setSelection] = React.useState(0)
    const [open, setOpen] = React.useState(false);
    const [edit, setEdit] = React.useState(false);
    const [data, setData] = React.useState(null);
    const [user, setUser] = React.useState(userInfo);
    const [userSelect, setUserSelect] = React.useState(0);
    const [userFilter, setUserFilter] = React.useState(null);
    const [reload, setReload] = React.useState(true);

    const handleClose = () => setOpen(false);

    const reloadFunc = () => {
        setReload(!reload);
    }

    const createPO = () => {
        setOpen(true);
        setEdit(false);
        setData(null);
    }

    const updatePO = (array) => (rowd, rowState) => {
        console.log(array, rowState)
        reloadFunc();
        setEdit(false);
        setData(array[rowState.dataIndex]);
        setOpen(true);
    }

    return (
        <React.Fragment>
            <FormModal open={open} handleClose={handleClose} title={"Add/Edit Role"} >
                <AddRole completed={edit} data={data} access={props.access} reload={reloadFunc} handleClose={handleClose} />
            </FormModal>


            <Grid container spacing={3.5}>
                <Grid item xs={12}>
                    <Button onClick={createPO} variant="contained" >Create New Role</Button>
                </Grid>

                <Grid item xs={12}>
                    <Roles reload={reload} reloadFunc={reloadFunc} access={props.access} onClick={updatePO} dashboard />
                </Grid>
            </Grid>
        </React.Fragment >
    );
};

export default RolesPage;
